module.exports = __webpack_public_path__ + "teqbahn-assets/media/1.0a8d3571.jpg";